export enum SubjectReconciliationModalStateId {
  BankLines = 'bankLines',
  ConnectBank = 'connectBank',
  ImportCsv = 'importCsv',
  ManualPayment = 'manualPayment',
  MultipleSubjects = 'multipleSubjects',
  Match = 'match',
  Prepayment = 'prepayment',
}
